<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>组合商品管理</el-breadcrumb-item>
            <el-breadcrumb-item>组合商品{{ pageType }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row :gutter="0">
                <el-col :span="12">
                    <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
                        style="width:300px;" @clear="getproductList" @change="getproductList">
                        <el-button slot="append" icon="el-icon-search" @click="getproductList"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="addDialog" v-if="caozuo_type !== '1'">添加门店</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="0" class="el_row_two">
                <el-col :span="24">
                    <el-table :data="productList" style="width: 100%" border stripe @row-click="rowClickEv">

                        <el-table-column prop="pro_bianhao" label=" 编号" width="150"></el-table-column>
                        <el-table-column prop="pro_name" label="名称" width="450"></el-table-column>

                        <el-table-column prop="pro_price_shichang" label="市场价">
                        </el-table-column>
                        <el-table-column prop="pro_price_huiyuan" label="会员价">
                        </el-table-column>
                        <el-table-column prop="pro_price_pifa" label="批发价"> </el-table-column>
                        <el-table-column prop="pro_price_gaoji" label="高级会员价">
                        </el-table-column>
                        <el-table-column label="操作" width="300px" v-if="false">
                            <template v-slot="scope">
                                <el-input-number v-model="scope.row.count" :min="1" :max="100000" style="width: 140px;"
                                    label="描述文字"></el-input-number>
                                <el-button @click="kucun_chuku_add(scope.$index, scope.row.kucun_uid, scope.row.uid, scope.row.pro_bianhao, scope.row.pro_name, scope.row.pro_type, scope.row.leixing01, scope.row.leixing02, scope.row.leixing03, scope.row.leixing04, scope.row.count,
                                    guest_level_parent === 1 ? scope.row.pro_price_shichang
                                        : guest_level_parent === 2 ? scope.row.pro_price_huiyuan
                                            : scope.row.pro_price_gaoji, scope.row.pro_code)" type="primary"
                                    plain style="margin-left: 10px;">添加</el-button>
                                <!-- 读出数量，在添加的时候，就要做数量上的判断 -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <!-- 分页 -->
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
                <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
            </el-pagination>
        </el-card>
    </div>
</template>
<script>
import { checkMobileTest } from '../config/validator'

export default {
    components: {

    },
    /* 
     caozuo_type   1 浏览 2 管理修改删除
     pageType 1 可以进行选择  4 显示所有明细 
     mingxi_type 1 2  用来显示客户明细
     mingxiMain_type 1 2  显示门店明细类别
    */
    props: ['caozuo_type', 'pageType', 'mingxi_type', 'mingxiMain_type'],
    data() {
        // var checkMobile = (rule, value, cb) => {
        //  const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        // if (regMobil.test(value)) {
        //    return cb()
        //  }
        //  cb(new Error('请输入合法的手机号!'))
        //  }
        return {
            yunying_qiye_uid: 0,
            datekey: Date.now(),
            queryInfo: {
                C_type: 'get_list_more',
                C_table_name: 'product_list08', // 04 为读取有库存的所有商品
                query: '',
                pageNum: 1,
                pageSize: 10,
                CI_canshu01: this.mendianUid, // 门店qiye_uid window.sessionStorage.getItem('qiye_uid')
                CI_canshu02: 1078, // 商品类型uid 固定1078 为组合类型商品
                CI_canshu03: 1 //  1 无库存也显示 2 只显示有库存的商品
            },
            productList: [],
            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            shigongDialogVisible: false,
            kucunDialogVisible: false,
            rukuDialogVisible: false,
            chukuDialogVisible: false,

            add_isDisable: false,
            //  添加表单数据项
            addForm: {
                C_type: 'qiye_add',
                qiye_bianhao: '',
                qiye_name: '',
                qiye_lxr: '',
                qiye_mob: '',
                qiye_xuliehao: '',
                qiye_type: ' ',
                qiye_tel: ' ',
                qiye_addr: ' ',
                pics_one: '',
                pics: ''
            },
            pics_one: '',
            pics: '',
            // 用于修改数据绑定
            editForm: {},
            // 表单规则项
            addFormRules: {
                qiye_type: [
                    { required: true, message: '选择类型', trigger: 'change', type: 'number' }
                ],
                qiye_name: [
                    { required: true, message: '请输入门店名称', trigger: 'blur' },
                    { min: 1, max: 30, message: '必须1到30位字符 ', trigger: 'blur' }
                ],
                qiye_lxr: [
                    { required: true, message: '请输入门店管理员', trigger: 'blur' },
                    { min: 1, max: 10, message: '必须1到10位字符', trigger: 'blur' }
                ],
                qiye_mob: [
                    { validator: checkMobileTest.bind(this.addForm && this.addForm.qiye_mob) }

                ]
            }
        };
    },
    created() {
        this.getproductList()
    },
    methods: {
        rowClickEv(data) {
            console.log(data)
            this.getProductInfo(data.uid, data.pro_bianhao, data.pro_name, data.pro_price_shichang, data.pro_price_huiyuan, data.pro_price_gaoji, data.pro_price_pifa, data.zuheProductlist)
            this.mendianUidSelect = data.row
        },
        getProductInfo(uid, bianhao, proName, priceShichang, priceHuiyuan, priceGaoji, pricePifa, zuheProductlist) {
            console.log(uid)
            // console.log(this.mendianUidSelect)
            //  this.mendianUidSelect = uid
            this.productUidInfo = {
                uid: uid,
                bianhao: bianhao,
                pro_name: proName,
                price_shichang: priceShichang,
                price_huiyuan: priceHuiyuan,
                price_gaoji: priceGaoji,
                price_pifa: pricePifa,
                zuheProductlist: zuheProductlist // 把已有的数据，要传递到下个页面的列表中
            }
            this.$emit('getProductInfo', this.productUidInfo)
        },
        async getproductList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            console.log(1110, JSON.parse(res.data)[0].dataList)
            this.productList = JSON.parse(res.data)[0].dataList
            if (!this.productList) return;
            this.productList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });
            this.total = JSON.parse(res.data)[0].total;
        },

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getproductList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getproductList();
        },

        async qiyeInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'qiye_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            console.log(res.data)
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }

            this.editForm = JSON.parse(res.data)[0].data[0];
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
}

.el_row_two {
    margin-top: 30px;
}
</style>
